require('./tab.tag');
riot.tag2('tab-panel', '<yield></yield>', '', 'class="tab-panel"', function(opts) {
    var self = this;

    self.mixin('bus');
});;
